import * as c from '../constants/AppConstants'

const initialState = {
  modal: {
    name: null,
    props: null,
    transitioning: false
  },
  detailPanel: {
    name: null,
    props: null,
    closing: false
  },
  breakpoint: {
    name: null,
    prefix: null,
    width: null
  },
  smallViewport: false,
  tab: null,
  error: null
}

const modal = (state = {}, { type, name, props }) => {
  switch (type) {
    case c.MODAL_OPEN:
      return { ...state, name, props }
    case c.MODAL_START_CLOSE:
      return { ...state, transitioning: true }
    case c.MODAL_FINISH_CLOSE:
      return { ...state, name, transitioning: false }
    default:
      return state
  }
}

const detailPanel = (state = {}, { type, name, props }) => {
  switch (type) {
    case c.DETAIL_PANEL_OPEN:
      return { ...state, name, props }
    case c.DETAIL_PANEL_START_CLOSE:
      return { ...state, closing: true }
    case c.DETAIL_PANEL_FINISH_CLOSE:
      return { ...state, name: null, props: null, closing: false }
    default:
      return state
  }
}

export default (state = initialState, actions) => {
  switch (actions.type) {
    case c.MODAL_OPEN:
    case c.MODAL_START_CLOSE:
    case c.MODAL_FINISH_CLOSE:
      return { ...state, modal: modal(state.modal, actions) }
    case c.DETAIL_PANEL_OPEN:
    case c.DETAIL_PANEL_START_CLOSE:
    case c.DETAIL_PANEL_FINISH_CLOSE:
      return { ...state, detailPanel: detailPanel(state.detailPanel, actions) }
    case c.GENERIC_APP_ERROR:
      return { ...state, error: actions.payload.message }
    case c.CHANGE_BREAKPOINT:
      return { ...state, breakpoint: { ...actions.payload }, smallViewport: /* actions.payload.name === 'desktop' || */ actions.payload.name === 'tablet' || actions.payload.name === 'mobile' }
    case c.SET_ACTIVE_TAB:
      return { ...state, tab: actions.payload }
    default:
      return state
  }
}
